require('@/utils/extensions');

var getLabelValue = function (riskLabel, label) {
    return riskLabel === null || typeof(riskLabel) === 'undefined' ? label : riskLabel.label;
};
var getHelpTextValue = function (riskLabel, helpText) {
    return riskLabel === null || typeof(riskLabel) === 'undefined' ? helpText : riskLabel.helpText ;
};

var showTooltip = function(show, text){
    var displayTooltip = show && text !== null && typeof(text) !== 'undefined' && text.length > 0 && text != 'NULL';
    return displayTooltip;
};

export default {
    methods: {
        getLabelValue,
        getHelpTextValue,
        showTooltip
    }
};
